import { Check } from "lucide-react";
import { MaskReveal, Reveal } from "../components/Reveal";
import { CTASection } from "../components/CTASection";
import { WhatsAppButton } from "../components/WhatsAppButton";
import { Seo } from "../components/Seo";
import { MEMBERSHIPS } from "../data/siteData";

export default function Membership() {
  return (
    <>
      <Seo
        title="Spa Membership Plans in Suchitra | Belong Salon & Spa"
        description="Silver, Gold & Platinum spa memberships at Belong Salon & Spa, Suchitra, Hyderabad — monthly massage sessions, private suite privileges & member pricing on request."
        keywords="spa membership Hyderabad, massage membership Suchitra, monthly spa packages, Belong spa membership"
      />
      <section className="relative overflow-hidden pb-16 pt-44" data-testid="membership-hero">
        <div className="ambient-glow pointer-events-none absolute inset-0" />
        <div className="relative mx-auto max-w-7xl px-6 text-center lg:px-10">
          <MaskReveal delay={0.15} className="flex justify-center">
            <p className="font-mono-alt text-[11px] uppercase tracking-[0.35em] text-amber-400/80">Membership</p>
          </MaskReveal>
          <h1 className="mt-8 font-display text-4xl font-light leading-[1.06] tracking-tight text-amber-50 sm:text-6xl lg:text-7xl">
            <MaskReveal delay={0.3}>For those who return</MaskReveal>
            <MaskReveal delay={0.45}>
              <em className="text-gold-gradient not-italic">to themselves.</em>
            </MaskReveal>
          </h1>
          <MaskReveal delay={0.65} className="mx-auto mt-8 max-w-2xl">
            <p className="text-base font-light leading-relaxed text-stone-400 sm:text-lg">
              Three tiers of monthly devotion — sessions, privileges and a concierge who knows your
              preferred oil by heart. Pricing is personalised; enquire on WhatsApp.
            </p>
          </MaskReveal>
        </div>
      </section>

      <section className="pb-28 pt-10" data-testid="membership-tiers">
        <div className="mx-auto grid max-w-7xl items-stretch gap-6 px-6 lg:grid-cols-3 lg:px-10">
          {MEMBERSHIPS.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.12} className="h-full">
              <div
                data-testid={`membership-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`relative flex h-full flex-col rounded-3xl border p-9 transition-all duration-500 ${
                  m.featured
                    ? "border-amber-400/50 bg-gradient-to-b from-amber-400/10 to-[#121215] shadow-[0_0_50px_rgba(212,175,55,0.12)] lg:-translate-y-4"
                    : "border-white/8 bg-[#121215] hover:border-amber-500/25"
                }`}
              >
                {m.featured && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-amber-400 px-4 py-1 font-mono-alt text-[9px] uppercase tracking-[0.22em] text-[#0B0B0C]">
                    {m.badge}
                  </span>
                )}
                <p className={`font-mono-alt text-[10px] uppercase tracking-[0.3em] ${m.featured ? "text-amber-300" : "text-stone-500"}`}>
                  {m.featured ? "Tier II" : i === 0 ? "Tier I" : "Tier III"}
                </p>
                <h2 className="mt-4 font-display text-3xl font-light text-amber-100">{m.name}</h2>
                <p className="mt-5 font-display text-2xl font-light text-gold-gradient">Price on request</p>
                <p className="mt-1 font-mono-alt text-[9px] uppercase tracking-[0.22em] text-stone-500">
                  Personalised quote on enquiry
                </p>
                <ul className="mt-8 flex-1 space-y-4">
                  {m.features.map((f) => (
                    <li key={f} className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-400/15">
                        <Check className="h-3 w-3 text-amber-300" />
                      </span>
                      <span className="text-sm font-light leading-relaxed text-stone-300">{f}</span>
                    </li>
                  ))}
                </ul>
                <WhatsAppButton
                  message={`Hello Belong Spa, I would like to know more about the ${m.name} membership.`}
                  label="Enquire on WhatsApp"
                  testid={`membership-enquire-btn-${m.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className="mt-10 w-full"
                />
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mx-auto mt-14 max-w-2xl px-6 text-center">
          <p className="text-sm font-light leading-relaxed text-stone-500" data-testid="membership-note">
            Membership pricing is tailored to your rhythm and finalised in person or over WhatsApp —
            no hidden terms, no lock-ins you didn’t ask for.
          </p>
        </Reveal>
      </section>

      <CTASection
        eyebrow="Still Deciding?"
        copy="Try a single session first. Most of our members began exactly the same way."
      />
    </>
  );
}
